<app-record-card-generic>
  <ng-template appRecordCardGenericLeft>
    <opac-record-cover
      [coverUrl]="record.coverImageUrl"
      [icon]="record.icon"></opac-record-cover>
  </ng-template>
  <ng-template appRecordCardGenericRight>
    <div class="card__right">
      <div class="card__record-info">
        <div class="record-title">
          <p class="card__info__title" [appRecordTitle]="record" tabindex="0"></p>
        </div>

        <p
          class="card__info__author"
          tabindex="0"
          *ngIf="record.author"
          [attr.aria-label]="('search.criteria.author' | translate) + ' ' + record.author">
          {{record.author}}
        </p>
        <p
          class="card__info__publisher"
          tabindex="0"
          *ngIf="record.publisher"
          [attr.aria-label]="('search.criteria.publisher' | translate) + ' ' + record.publisher">
          {{record.publisher}}
        </p>
        <div
          class="card__info__description fade-description"
          tabindex="0"
          *ngIf="record.description"
          [innerHTML]="record.description"></div>
      </div>

      <div class="card__info__actions">
        <div class="wrapper">
          <ng-container *ngIf="suggestion && suggestion.status !== 'BOUGHT' then suggested else suggest"></ng-container>

          <div
            [ngPlural]="requestedBy"
            class="blue-chip"
            *ngIf="requestedBy && solutionType !== SOLUTION_UNLIMITED"
            tabindex="0">
            <ng-template ngPluralCase="=1"
              >{{requestedBy}} {{'results.suggestions.requestedBySingular' | translate}}</ng-template
            >
            <ng-template ngPluralCase="other"
              >{{requestedBy}} {{'results.suggestions.requestedByPlural' | translate}}</ng-template
            >
          </div>

          <div class="blue-chip" *ngIf="alreadyInLibrary" tabindex="0">
            {{'results.suggestions.alreadyInLibrary' | translate}}
          </div>
        </div>
      </div>
    </div>

    <ng-template #suggested>
      <button
        mat-flat-button
        *ngIf="suggestion.status !== 'REFUSED'"
        class="accent transparent"
        (click)="cancelSuggestion()">
        {{'results.suggestions.cancel' | translate}}
      </button>

      <button mat-flat-button disabled *ngIf="suggestion.status === 'REFUSED'" class="accent transparent">
        {{'results.suggestions.refused' | translate}}
      </button>
    </ng-template>

    <ng-template #suggest>
      <button
        mat-flat-button
        class="accent"
        *ngIf="!(solutionType === SOLUTION_UNLIMITED && alreadyInLibrary)"
        (click)="suggestTitle()">
        {{suggestButtonText | translate}}
      </button>
    </ng-template>
  </ng-template>
</app-record-card-generic>
